import { render } from "./AddAddress.vue?vue&type=template&id=438d6596&ts=true"
import script from "./AddAddress.vue?vue&type=script&lang=ts"
export * from "./AddAddress.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__